import { render, staticRenderFns } from "./WinOrLose.vue?vue&type=template&id=782b272a&scoped=true&"
import script from "./WinOrLose.vue?vue&type=script&lang=js&"
export * from "./WinOrLose.vue?vue&type=script&lang=js&"
import style0 from "./WinOrLose.vue?vue&type=style&index=0&id=782b272a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b272a",
  null
  
)

export default component.exports